import { BooleanStateStorage } from "../../../utils/BooleanStateStorage";
import {
  LayoutPreferenceKey,
  LayoutPreferences,
  STORAGE_KEY,
  isLayoutPreferences,
} from "./LayoutPreferencesStorage.types";

class LayoutPreferencesStorage extends BooleanStateStorage<LayoutPreferenceKey> {
  protected readonly storageKey = STORAGE_KEY;

  protected isValidState(value: unknown): value is LayoutPreferences {
    return isLayoutPreferences(value);
  }
}

export const layoutPreferencesStorage = new LayoutPreferencesStorage();
